import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useGetRootRedirectRoute } from "@/hooks/use-get-root-redirect-route/use-get-root-redirect-route";

function RootRedirect() {
	const redirectRoute = useGetRootRedirectRoute();
	return <Navigate to={redirectRoute} replace />;
}

export const Route = createFileRoute("/")({
	component: RootRedirect,
});
